import { useEffect, useState, useCallback } from "react";

const useThemeImage = (lightImage, darkImage) => {
  const [imageSrc, setImageSrc] = useState(lightImage);

  // Memoriza la función para evitar recrearla en cada render
  const updateImage = useCallback(() => {
    const computedStyle = window.getComputedStyle(document.documentElement);
    const bgColor = computedStyle.getPropertyValue("--bg-color").trim();

    if (bgColor === "#f7f4f2") {
      setImageSrc(lightImage);
    } else if (bgColor === "#252525") {
      setImageSrc(darkImage);
    } else {
      setImageSrc(lightImage);
    }
  }, [lightImage, darkImage]);

  useEffect(() => {
    updateImage();

    const handleThemeChange = () => updateImage();
    window.addEventListener("themeChange", handleThemeChange);

    return () => {
      window.removeEventListener("themeChange", handleThemeChange);
    };
  }, [updateImage]);

  return imageSrc;
};

export default useThemeImage;
